module.exports = __webpack_public_path__ + "img/148.d75e948d.jpg";